function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "#ADBBCD",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M1.264 5.303h14.405l-1 10.537c0 .966-.805 1.756-1.79 1.756H4.054c-.984 0-1.79-.79-1.79-1.756l-1-10.537zM5.5 8a.5.5 0 0 0-.5.5v4a.5.5 0 1 0 1 0v-4a.5.5 0 0 0-.5-.5zm3 0a.5.5 0 0 0-.5.5v4a.5.5 0 1 0 1 0v-4a.5.5 0 0 0-.5-.5zm3 0a.5.5 0 0 0-.5.5v4a.5.5 0 1 0 1 0v-4a.5.5 0 0 0-.5-.5zM15.75 3.653H.95A.945.945 0 0 1 0 2.72v-.396c0-.513.428-.933.95-.933h14.8c.523 0 .95.42.95.933v.396a.945.945 0 0 1-.95.933"
}), React.createElement("path", {
  d: "M11.705 2.12H4.943a.945.945 0 0 1-.95-.932V.933c0-.513.427-.933.95-.933h6.762c.523 0 .95.42.95.933v.255a.945.945 0 0 1-.95.933"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 17,
    height: 18
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/Bin.8f2ed1d8.svg";
export { SvgComponent as ReactComponent };